<template>
  <div style="padding-bottom: 1%;">
    <div class="col-12 col-md-6" style="margin-top: 2%;">
      <base-select v-model="form.equipmentType"
                   :options="equipmentList"
                   label="Equipment Type"
                   placeholder="Equipment Type"
                   :validation="$v.form.equipmentType"
                   @change="resetOption">
      </base-select>
    </div>
    <div class="col-12 col-md-6"> </div>
    <div class="col-12 col-md-6" v-if="form.equipmentType == 'Storage Tanks'">
      <base-select v-model="form.level2Option"
                   :options="currentUseCodes"
                   label=" Equipment Use"
                   :validation="$v.form.level2Option">
      </base-select>
    </div>
    <div class="col-12 col-md-6" v-if="form.equipmentType == 'Storage Tanks'"> </div>
    <div class="col-12 col-md-6" v-if="(form.level2Option != null && form.level2Option != '') || (form.equipmentType != null && form.equipmentType != '' && form.equipmentType != 'Storage Tanks' && form.equipmentType != 'Processing')">
      <label class="required">{{this.currentMetricOptions[0].text}} &nbsp</label>
      <base-input v-model="form.usageMetric"
                  :placeholder="this.currentMetricOptions[0].text"
                  type="number"
                  min="0"
                  :validation="$v.form.usageMetric">
      </base-input>
    </div>
    <div class="col-12 col-md-6" v-if="(form.level2Option != null && form.level2Option != '') || (form.equipmentType != null && form.equipmentType != '' && form.equipmentType != 'Storage Tanks' && form.equipmentType != 'Processing')"> </div>
    <div class="col-12 col-md-6" v-if="form.equipmentType == 'Processing' || form.usageMetric != null"> <!--(form.level2Option != null && form.level2Option != '')-->
      <label class="required"> Quantity on Site </label>
      <base-input v-model="form.quantity"
                  type="number"
                  min="1"
                  :validation="$v.form.quantity">
      </base-input>
    </div>
    <div class="col-12 col-md-6" v-if="(form.equipmentType == 'Processing' || form.usageMetric != null) &&  form.equipmentType != 'Control Device'">
      <!--(form.level2Option != null && form.level2Option != '')-->
      <label class="required"> Equipment Description </label>
      <base-input v-model="form.description"
                  maxlength="75"
                  :validation="$v.form.description">
      </base-input>
    </div>
        <div class="col-12 col-md-6" v-if="form.usageMetric != null &&  form.equipmentType == 'Control Device'">
      <!--(form.level2Option != null && form.level2Option != '')-->
      <label class="required"> Equipment Description (e.g. Baghouse, Thermal Oxidizer, etc.)</label>
      <base-input v-model="form.description"
                  maxlength="75"
                  :validation="$v.form.description">
      </base-input>
    </div>
    <div class="col-12 col-md-6" v-if="form.equipmentType == 'Processing' || form.usageMetric != null"></div>
    <div class="col-12 col-md-12">
      <button @click="addMore" class="btn btn-primary eDetailElement">
        + Add Equipment
      </button>
      <button @click="showFAQ" class="btn btn-warning eDetailElement">
        Help
      </button>
    </div>
    <div v-if="form.equipmentList.length > 0" style="width: 95%; margin-top: 2%;">
      <div class="col-12 col-md-12">
        <div style="border-top: 1px solid rgb(89, 149, 247);"> </div>
      </div>
      <h5 class="m-l-1" style="margin-top: 3%;"> Pending Equipment Additions </h5>
      <div style="margin-top: 2%;">
        <div class="col-12 col-md-8 e-item eDetailElement" style="display: flex;" v-for="(item, index) in form.equipmentList">
          <div class="equipment-info-container">
            <h5 class="equipment-info"> {{item.equipmentTypeCode}}</h5>
            <div v-if="isSmall == false" class="equipment-info-divider"></div>
            <h5 class="equipment-info"> Qty: {{item.quantity}} </h5>
            <div v-if="item.equipmentTypeCode != 'Processing' && isSmall == false" class="equipment-info-divider"></div>
            <h5 v-if="item.equipmentTypeCode != 'Processing'" class="equipment-info"> {{item.metricOption}}: {{item.usageMetric}}</h5>
          </div>
          <button @click="removeEquipment(index)" class="btn btn-primary expanded-button removeButton">
            X
          </button>
        </div>
      </div>
      <button @click="goToFileUpload" class="btn btn-success eDetailElement">
        Proceed to File Upload
      </button>
    </div>
  </div>
</template>
<script>
import { AirAddEquipmentForm } from '@/js/FormObjects';
import BaseInput from '@/components/BaseInput';
import BaseSelect from '@/components/BaseSelect';
import BaseFileUploader from '@/components/BaseFileUploader';
import BaseTextarea from '@/components/BaseTexarea';
import { AddEquipmentValidations } from '@/js/FormValidations';
import { getTypeCodes, getUseCodes, getUsageMetricCodes, uploadFile } from '@/js/FormFunctions';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);

export default {
  name: 'AddEquipmentDetails',
  components: {
    BaseInput, BaseSelect, BaseFileUploader, BaseTextarea,
  },
  props: ['siteNumber'],
  data() {
    return {
      equipmentList: [],
      useCodes: [],
      currentUseCodes: [],
      usageCodes: [],
      metricOptions: [],
      currentMetricOptions: [{ value: null, text: '' }],
      form: this.$parent.form,
      fetchingData: false,
      currentUsagePlaceholder: null,
    };
  },
  validations: {
    form: new AddEquipmentValidations(),
  },
  mounted() {
    const vm = this;
    if (this.form.equipmentType != null && this.form.equipmentType != '') {
      this.form.equipmentType = null;
    }
    getTypeCodes(this.siteNumber)
      .then((data) => {
        vm.fetchingData = false;
        for (var i = 0; i < data.data.length; i++) {
          vm.equipmentList.push(JSON.stringify({ value: data.data[i].code, text: data.data[i].description }));
        }
        for (var i = 0; i < data.data.length; i++) {
          vm.equipmentList[i] = JSON.parse(vm.equipmentList[i]);
        }
        getUseCodes()
          .then((data) => {
            vm.fetchingData = false;
            for (var i = 0; i < data.data.length; i++) {
              vm.useCodes.push(JSON.stringify({ etypecode: data.data[i].equipmentTypeCode, value: data.data[i].code, text: data.data[i].description }));
            }
            for (var i = 0; i < data.data.length; i++) {
              vm.useCodes[i] = JSON.parse(vm.useCodes[i]);
            }

            getUsageMetricCodes()
              .then((data) => {
                vm.fetchingData = false;
                for (var i = 0; i < data.data.length; i++) {
                  vm.metricOptions.push(JSON.stringify({ etypecode: data.data[i].equipmentTypeCode, value: data.data[i].code, text: data.data[i].description }));
                }
                for (var i = 0; i < data.data.length; i++) {
                  vm.metricOptions[i] = JSON.parse(vm.metricOptions[i]);
                }
              })
              .catch(() => {
                vm.fetchingData = false;
              });
          })
          .catch(() => {
            vm.fetchingData = false;
          });
      })
      .catch(() => {
        vm.fetchingData = false;
      });
  },
  methods: {
    addMore() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$notify('Errors adding equipment to site', 'error');
      } else {
        let metricText = null;
        if (this.currentMetricOptions[0] == null) {
          metricText = null;
        } else {
          metricText = this.currentMetricOptions[0].text;
        }
        if (this.form.equipmentType == 'Fuel Burning') {
          this.form.level2Option = 'Heating';
        }
        const addEquipmentRequest = {
          siteNumber: this.siteNumber,
          equipmentTypeCode: this.form.equipmentType,
          equipmentUseCode: this.form.level2Option,
          metricOption: metricText,
          usageMetric: this.form.usageMetric,
          // level2Option: this.form.level2Option,
          // fileList: this.form.fileList,
          // fileTypeList: this.form.fileTypes,
          quantity: this.form.quantity,
          description: this.form.description,
        };
        this.form.equipmentList.push(addEquipmentRequest);
        this.form.equipmentType = null;
        this.form.level2Option = null;
        this.form.quantity = null;
        this.form.usageMetric = null;
        this.currentMetricOptions = [];
        this.currentUseCodes = [];
        this.form.description = null;
        this.$v.$reset();
        this.$swal('Equipment Added!', null, 'success');
      }
    },
    removeEquipment(index) {
      this.$swal({
        title: 'Remove Equipment?',
        text: 'Equipment cannot be recovered.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Remove Equipment',
      }).then((result) => {
        if (result.value) {
          if (index >= 0) {
            this.form.equipmentList.splice(index, 1);
          }
          this.$swal.fire(
            'Equipment Removed',
            null,
            'success',
          );
        }
      });
    },
    resetOption() {
      this.form.level2Option = null;
      return this.form.level2Option;
    },
    goToFileUpload() {
      this.$router.push({ name: 'EquipmentFileUpload', query: this.$route.query });
    },
    showFAQ() {
      const route = this.$router.resolve({ name: 'EquipmentDetailsFAQ' });
      window.open(route.href, '_blank');
    },
  },
  computed: {
    isSmall() {
      const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      return width < 760;
    },
  },
  watch: {
    'form.equipmentType': function () {
      this.form.level2Option = null;
      this.form.description = null;
      this.currentUseCodes = Object.assign({}, this.useCodes.filter(x => x.etypecode == this.form.equipmentType));
      for (var i = 0; i < this.currentUseCodes.length; i++) {
        delete this.currentUseCodes[i].etypecode;
        this.currentUseCodes[i] = JSON.parse(JSON.stringify(this.currentUseCodes[i]));
      }
      if (this.form.equipmentType != 'Storage Tanks') {
        this.currentMetricOptions = Object.assign({}, this.metricOptions.filter(x => x.etypecode == this.form.equipmentType));
        for (var i = 0; i < this.currentMetricOptions.length; i++) {
          this.currentMetricOptions[i] = JSON.parse(JSON.stringify(this.currentMetricOptions[i]));
        }
      }
    },
    'form.level2Option': function () {
      if (this.form.level2Option != null && this.form.level2Option != '') {
        const index = this.useCodes.filter(x => x.etypecode == this.form.equipmentType).map(option => option.value).indexOf(this.form.level2Option) - 1;

        this.currentMetricOptions = Object.assign({}, this.metricOptions.filter(x => x.etypecode == this.form.equipmentType));

        for (let i = 0; i < this.currentMetricOptions.length; i++) {
          this.currentMetricOptions[i] = JSON.parse(JSON.stringify(this.currentMetricOptions[i]));
          this.currentUsagePlaceholder = this.currentMetricOptions[i].text;
        }
      } else {
        this.form.quantity = null;
        this.form.usageMetric = null;
        this.form.description = null;
      }
    },
  },
};
</script>
